/* 🤖 this file was generated by svg-to-ts */
export const siriusFlaskPictogram: {
  name: 'flask_pictogram';
  data: string;
} = {
  name: 'flask_pictogram',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" style="display: block;"><path d="M19.5 5a1 1 0 0 1 1 1v11.594c-.003.441-.12.874-.337 1.257l-.012.02L8.227 38.744a.502.502 0 0 0 .175.687.5.5 0 0 0 .247.069h30.702a.5.5 0 0 0 .422-.756L27.849 18.87l-.012-.02a2.576 2.576 0 0 1-.337-1.257V6a1 1 0 1 1 2 0v11.583a.575.575 0 0 0 .071.271L41.49 37.719a2.5 2.5 0 0 1-2.125 3.781H8.636a2.5 2.5 0 0 1-2.126-3.781l.001-.002L18.43 17.854a.576.576 0 0 0 .071-.27V6a1 1 0 0 1 1-1Z" fill="currentColor"/></svg>`
};
